module.exports = __webpack_public_path__ + "static/media/Emily Svensson.e6cc80cb.png";